import {
  FILTER_HOVER_TIP_PANEL_ROOT_MARKERS,
  FILTER_HOVER_TIP_PANEL_SELECTORS,
  FILTER_HOVER_TIP_TRIGGER_SELECTORS,
} from './filterHoverTipSelectors';

const matchesAny = (element: Element, selectors: readonly string[]): boolean =>
  selectors.some(selector => element.closest(selector));

const hasPanelRoot = (wrapper: HTMLElement): boolean =>
  FILTER_HOVER_TIP_PANEL_ROOT_MARKERS.some(selector =>
    Boolean(wrapper.querySelector(selector)),
  );

export const resolveFilterHoverTipVisibility = (
  target: EventTarget | null,
  wrapper: HTMLElement,
): boolean => {
  if (!target || !(target instanceof Element)) {
    return false;
  }

  if (!wrapper.contains(target)) {
    return false;
  }

  if (matchesAny(target, FILTER_HOVER_TIP_PANEL_SELECTORS)) {
    return false;
  }

  if (matchesAny(target, FILTER_HOVER_TIP_TRIGGER_SELECTORS)) {
    return true;
  }

  if (!hasPanelRoot(wrapper)) {
    return true;
  }

  return false;
};
